import React, { useCallback, useState } from "react";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { Base } from "../../../framework/base";

export const MuiDataGridDateTimePicker = ({
    id,
    field,
    value,
    hasFocus,
    format,
    dateOnly,
}: GridRenderEditCellParams & { format?: string; dateOnly?: boolean }) => {
    const apiRef = useGridApiContext();

    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(
        value ? Base.dateStrToDayjsIgnoreTimezone(value) : null
    );

    const handleDateChange = useCallback(
        async (date: Dayjs | null) => {
            setSelectedDate(date);
            const newValue = date
                ? dateOnly
                    ? Base.dayjsToJsonDate(date)
                    : Base.dayjsToJsonDateTime(date)
                : "";
            await apiRef.current.setEditCellValue({
                id,
                field,
                value: newValue,
            });
        },
        [apiRef, id, field, dateOnly]
    );

    const PickerComponent = dateOnly ? DatePicker : DateTimePicker;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fi">
            <PickerComponent
                value={selectedDate}
                onChange={handleDateChange}
                format={format ?? (dateOnly ? "D.M.YYYY" : "D.M.YYYY H:mm")}
                ampm={false}
                slotProps={{
                    textField: {
                        size: "small",
                        variant: "standard",
                        fullWidth: true,
                        sx: { fontSize: "0.875rem" },
                        autoFocus: hasFocus,
                    },
                }}
            />
        </LocalizationProvider>
    );
};
